<template>
  <div class="vheader">
    <!--left-->
    <div class="vc-flex">
      <IconView @click="goback" svgname="ic_left1" backColor="var(--ek-card-color2)" :iconSize="16" :ctnSize="32"
        :radius="20"></IconView>
      <div class="bookName">{{ bookInfo != null ? bookInfo.bookName : '加载中..' }}</div>
    </div>
    <!--right-->
    <div>
      <ThemeSwitchView></ThemeSwitchView>
    </div>
  </div>
</template>

<script>
import IconView from '@/components/IconView.vue';
import ThemeSwitchView from '@/components/ThemeSwitchView.vue';
import deschelper from '@/commom/epct/DesHelper.js';
export default {
  name: 'BookDetailsHeader',
  components: {
    IconView,
    ThemeSwitchView
  },
  props: {
    bookInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    //返回上一级
    goback: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vheader {
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: space-between;
  background: var(--ek-mainbody-bgcolor);
  margin-bottom: 20px;
  box-shadow: 3px 3px 5px #00000008;
}

.bookName {
  margin-left: 10px;
  color: var(--ek-text-color2);
}

.bntlearn {
  background: var(--ek-color-primary);
  height: 35px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: white;
  font-size: 14px;
}
/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
  .vheader {
    height: 55px;
  }

}
</style>
